module.exports = __webpack_public_path__ + "phoneIco.webp?b191b6e627544ce009156efe78de3ab1";